import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatHint, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslocoPipe } from '@jsverse/transloco';
import { Observable } from 'rxjs';

import { BaseControlComponent } from '~components/form/base-control/base-control.component';
import { ErrorTooltipDirective } from '~core/directives/error-tooltip.directive';

@Component({
    selector: 'arc-input',
    templateUrl: './input.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        MatFormField,
        ErrorTooltipDirective,
        MatLabel,
        MatInput,
        ReactiveFormsModule,
        MatSuffix,
        MatHint,
        MatIconButton,
        MatIcon,
        MatProgressSpinner,
        TranslocoPipe
    ]
})
export class InputComponent extends BaseControlComponent {
    @HostBinding('class') classes = 'grow';
    @Input() type = 'text';
    @Input() minLength?: number;
    @Input() maxLength?: number;
    @Input() inputSize?: number;
    @Input() step?: number;
    @Input() suffix?: string;
    @Input() icon?: string;
    @Input() showTextCount?: boolean;
    /**
     * Callback function to be added as an suffix icon.
     */
    @Input() action?: (control: FormControl) => Observable<any>;
    /**
     * The name of the icon to be used for the callback function.
     */
    @Input() actionIcon?: string;

    isActionLoading = false;

    executeAction(): void {
        if (!!this.action) {
            this.isActionLoading = true;
            this.action(this.castedControl).subscribe({
                complete: () => (this.isActionLoading = false)
            });
        }
    }
}
